export { default } from './PartiuGpPremio';
